/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
'use strict';

// Use this variable to set up the common and page specific functions. If you
// rename this variable, you will also need to rename the namespace below.
var Sage = {
    // All pages
    'common': {
        init: function() {
            $(document).foundation();

            // Off Canvas close button
            var offCanvas = $('#off-canvas');
            offCanvas.on('opened.zf.offcanvas', function() {
                $('body').addClass('is-off-canvas-open');
            });
            offCanvas.on('closed.zf.offcanvas', function() {
                $('body').removeClass('is-off-canvas-open');
            });

            //Search form
            $(document).on('click', '.search-toggle', function(e) {
                e.preventDefault();
                var parent = $('.search-form');
                var input = $('.search-input');

                parent.toggleClass('show');

                if (parent.hasClass('show')) {
                    input.focus();
                }
            });

            // Job offers
            $(document).on('click', '.job-offer-item', function(e) {
                e.preventDefault();
                var offerUrl = $(this).data('offer-url');

                if (offerUrl) {
                    window.location = offerUrl;
                }
            });
        },
        finalize: function() {
            // JavaScript to be fired on all pages, after page specific JS is fired
        }
    },
};

// The routing fires all common scripts, followed by the page specific scripts.
// Add additional events for more control over timing e.g. a finalize event
var UTIL = {
    fire: function(func, funcname, args) {
        var fire;
        var namespace = Sage;
        funcname = (funcname === undefined) ? 'init' : funcname;
        fire = func !== '';
        fire = fire && namespace[func];
        fire = fire && typeof namespace[func][funcname] === 'function';

        if (fire) {
            namespace[func][funcname](args);
        }
    },
    loadEvents: function() {
        // Fire common init JS
        UTIL.fire('common');

        // Fire page-specific init JS, and then finalize JS
        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm, 'finalize');
        });

        // Fire common finalize JS
        UTIL.fire('common', 'finalize');
    }
};

// Load Events
$(document).ready(UTIL.loadEvents);


$(document).ready(function(){

    var isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;

    if( !isSafari ) {
        $.stellar({
            responsive: false,
            scrollProperty: 'scroll',
            horizontalScrolling: false,
            verticalScrolling: true,
        });
    }
});

})(jQuery); // Fully reference jQuery after this point.
